module.exports = __webpack_public_path__ + "static/media/golden-frame-custom-mat-rendering.c8173a50.webp";